import React, { Component } from 'react';

import {
  TextField,
  Button,
  Paper,
  Container,
  Item,
  FileInput,
  Chip,
  Avatar,
  ListItem,
  ListItemText,
  FeatureInput,
  CategorySearchInput,
} from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

import isEmpty from 'lodash/isEmpty';

import ToolSearchInput from '../../Tool/containers/ToolSearchInput';

const styleSheet = createStyleSheet('StackForm', theme => {
  return {
    paper: {
      padding: 16,
    },
    form: {},
    submitButton: {
      width: '100%',
      marginTop: 32,
    },

    chip: {
      margin: 4,
    },
  };
});

class ToolForm extends Component {
  state = {
    name: null,
    description: null,
    detail: null,
    url: null,
    imageId: null,
    imageUrl: null,
    toolsIds: [],
    categoriesIds: [],
    featuresIds: [],
    items: [],
    error: false,
  };

  handleTextFieldChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.validate()) {
      this.props.onSubmit(this.state);

      return this.setState({
        error: false,
      });
    }

    this.setState({
      error: true,
    });
  };

  validate = () => {
    const { name, toolsIds } = this.state;

    if (!name || isEmpty(toolsIds)) {
      return false;
    }

    return true;
  };

  render() {
    const { classes } = this.props;

    return (
      <Container justify="center">
        <Item md={6} lg={4}>
          <Paper elevation={4} className={classes.paper}>
            <form onSubmit={this.handleSubmit} className={classes.form}>
              <FileInput
                onSuccess={imageData => {
                  const { id, url } = imageData;
                  this.setState({
                    imageId: id,
                    imageUrl: url,
                  });
                }}
                onFailure={error => {
                  this.setState({
                    imageId: null,
                    imageUrl: null,
                  });
                }}
              />

              <TextField
                fullWidth
                label="이름 (필수)"
                helpText="어떤 스택을 추가하시는 건가요?"
                type="text"
                name="name"
                onChange={this.handleTextFieldChange}
                error={this.state.error}
                required
              />

              <ToolSearchInput
                fullWidth
                label="검색으로 사용하는 툴, 서비스 추가 (필수)"
                helperText="여러개 추가 가능"
                onAddItems={tools => {
                  this.setState({
                    toolsIds: tools.map(tool => tool.id),
                  });
                }}
                renderItem={item => {
                  const { id, name, image } = item;

                  return (
                    <Chip
                      key={id}
                      avatar={
                        image &&
                        image.url &&
                        <Avatar src={image && image.url} />
                      }
                      label={name}
                      className={classes.chip}
                    />
                  );
                }}
                renderSearchItem={data => {
                  const { id, name, image } = data;

                  return (
                    <ListItem dense button key={id}>
                      <Avatar alt={name} src={image && image.url} />
                      <ListItemText primary={name} />
                    </ListItem>
                  );
                }}
                error={this.state.error}
                required
              />

              <TextField
                fullWidth
                label="사이트"
                type="url"
                name="url"
                onChange={this.handleTextFieldChange}
              />

              <TextField
                fullWidth
                label="간단한 서비스 소개"
                type="text"
                name="description"
                onChange={this.handleTextFieldChange}
              />

              <TextField
                fullWidth
                label="서비스 소개(상세)"
                name="detail"
                rows="3"
                multiline
                onChange={this.handleTextFieldChange}
              />

              <FeatureInput
                fullWidth
                label="기능"
                helperText="여러개 추가 가능"
                name="features"
                type="text"
                onAdd={({ id, label, slug }) => {
                  this.setState(prevState => {
                    return {
                      featuresIds: [...prevState.featuresIds, id],
                    };
                  });
                }}
              />

              <CategorySearchInput
                fullWidth
                items={this.state.items}
                name="categoriesIds"
                type="text"
                label="검색으로 카테고리 추가 (필수)"
                helperText="여러개 추가 가능"
                onAddItems={items => {
                  this.setState({
                    categoriesIds: items.map(item => item.id),
                  });
                }}
                renderItem={item => {
                  const { id, label } = item;

                  return (
                    <Chip key={id} label={label} className={classes.chip} />
                  );
                }}
                renderSearchItem={data => {
                  const { id, label } = data;

                  return (
                    <ListItem dense button key={id}>
                      <ListItemText primary={label} />
                    </ListItem>
                  );
                }}
                error={this.state.error}
                required
              />

              <Button
                type="submit"
                raised
                color="primary"
                className={classes.submitButton}
              >
                스택 추가
              </Button>
            </form>
          </Paper>
        </Item>
      </Container>
    );
  }
}
export default withStyles(styleSheet)(ToolForm);



// WEBPACK FOOTER //
// ./src/App/Stack/components/StackForm.js